import { render, staticRenderFns } from "./YouMightAlsoLike.vue?vue&type=template&id=4cfd8a87&scoped=true&"
import script from "./YouMightAlsoLike.vue?vue&type=script&lang=js&"
export * from "./YouMightAlsoLike.vue?vue&type=script&lang=js&"
import style0 from "./YouMightAlsoLike.vue?vue&type=style&index=0&id=4cfd8a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd8a87",
  null
  
)

export default component.exports